var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserSolid = function SvgUserSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "user-solid_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10a3.332 3.332 0 1 0 0-6.667 3.332 3.332 0 0 0-3.333 3.334A3.332 3.332 0 0 0 10 10Zm0 1.667c-2.225 0-6.667 1.116-6.667 3.333v.833c0 .459.375.834.834.834h11.666a.836.836 0 0 0 .834-.834V15c0-2.217-4.442-3.333-6.667-3.333Z",
    fill: "currentColor"
  })));
};
export { SvgUserSolid as ReactComponent };